/****************************************************
 * Module Name:  userModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { Button } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "./../../style/modalstyle.css";
import BrokerMasterComponent from "../common/brokerMasterComponent";
import CustomerMasterComponent from "../common/customerMasterComponent";
import EmployeeMasterComponent from "../common/employeeMasterComponent";
import logo from '../../images/pansuriya.jpg'


const UserModal = ({ handleClose, show, userType }) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            {userType === "B"
              ? "Broker"
              : userType === "C"
                ? "Customer"
                : "Employee"}
            &nbsp;Master
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {userType === "B" ? (
            <BrokerMasterComponent editButton={false} />
          ) : userType === "C" ? (
            <CustomerMasterComponent editButton={false} />
          ) : (
            <EmployeeMasterComponent editButton={false} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserModal;
